import { render, staticRenderFns } from "./SkuEdit.vue?vue&type=template&id=fcf0835a&scoped=true"
import script from "./SkuEdit.vue?vue&type=script&lang=js"
export * from "./SkuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf0835a",
  null
  
)

export default component.exports